import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderActions: build.mutation<
      PostV2ProviderActionsApiResponse,
      PostV2ProviderActionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/actions`,
        method: "POST",
        body: queryArg.actionCreate,
      }),
    }),
    getV2ProviderActionsSuggested: build.query<
      GetV2ProviderActionsSuggestedApiResponse,
      GetV2ProviderActionsSuggestedApiArg
    >({
      query: () => ({ url: `/v2/provider/actions/suggested` }),
    }),
    postV2ProviderActionsByActionIdAccept: build.mutation<
      PostV2ProviderActionsByActionIdAcceptApiResponse,
      PostV2ProviderActionsByActionIdAcceptApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/actions/${queryArg.actionId}/accept`,
        method: "POST",
        body: queryArg.actionAccept,
      }),
    }),
    postV2ProviderActionsByActionIdReject: build.mutation<
      PostV2ProviderActionsByActionIdRejectApiResponse,
      PostV2ProviderActionsByActionIdRejectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/actions/${queryArg.actionId}/reject`,
        method: "POST",
        body: queryArg.actionReject,
      }),
    }),
    getV2ProviderEncountersByEncounterIdActionsSuggested: build.query<
      GetV2ProviderEncountersByEncounterIdActionsSuggestedApiResponse,
      GetV2ProviderEncountersByEncounterIdActionsSuggestedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/actions/suggested`,
      }),
    }),
    getV2ProviderNotesByNoteIdActionsSuggested: build.query<
      GetV2ProviderNotesByNoteIdActionsSuggestedApiResponse,
      GetV2ProviderNotesByNoteIdActionsSuggestedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/actions/suggested`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderActionsApiResponse =
  /** status 201 Created */ ActionResponse;
export type PostV2ProviderActionsApiArg = {
  actionCreate: ActionCreate;
};
export type GetV2ProviderActionsSuggestedApiResponse =
  /** status 200 OK */ ActionListResponse;
export type GetV2ProviderActionsSuggestedApiArg = void;
export type PostV2ProviderActionsByActionIdAcceptApiResponse = unknown;
export type PostV2ProviderActionsByActionIdAcceptApiArg = {
  actionId: string;
  actionAccept: ActionAccept;
};
export type PostV2ProviderActionsByActionIdRejectApiResponse = unknown;
export type PostV2ProviderActionsByActionIdRejectApiArg = {
  actionId: string;
  actionReject: ActionReject;
};
export type GetV2ProviderEncountersByEncounterIdActionsSuggestedApiResponse =
  /** status 200 OK */ ActionListResponse;
export type GetV2ProviderEncountersByEncounterIdActionsSuggestedApiArg = {
  encounterId: string;
};
export type GetV2ProviderNotesByNoteIdActionsSuggestedApiResponse =
  /** status 200 OK */ ActionListResponse;
export type GetV2ProviderNotesByNoteIdActionsSuggestedApiArg = {
  noteId: string;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type ActionResponse = {
  action_id: string;
  action_payload: {
    [key: string]: any;
  };
  action_type: string;
  created_at: string;
  encounter_id: string | null;
  patient?: PatientInfo | null;
  provider_id: string;
  state: string;
  updated_at: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ActionCreate = {
  action_payload: {
    [key: string]: any;
  };
  action_type: string;
  encounter_id?: string | null;
  patient_id?: string | null;
};
export type InsuranceSummary2 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary2[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type ActionResponse2 = {
  action_id: string;
  action_payload: {
    [key: string]: any;
  };
  action_type: string;
  created_at: string;
  encounter_id: string | null;
  patient?: PatientInfo2 | null;
  provider_id: string;
  state: string;
  updated_at: string;
};
export type ActionListResponse = {
  items: ActionResponse2[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ActionAccept = {
  action_payload?: {
    [key: string]: any;
  } | null;
};
export type ActionReject = {
  rejection_payload?: {
    [key: string]: any;
  } | null;
  rejection_reason?: string | null;
};
